module.exports = __webpack_public_path__ + "static/profil_picture-a158742bcbdb87ae98717254313a481e.jpg";